import { createContext, useContext } from 'react'
import { ApiClient, initApiClient } from '@frontend/lib/request'

import { CompanyDepartment, CompanyListDepartmentsFilterParam } from '@shared-types/department'
import { Collection, Identifier } from '@shared-types/util'

export interface CompanyDepartmentsClient {
  listDepartments: (
    companyId: Identifier,
    params?: CompanyListDepartmentsFilterParam
  ) => Promise<Collection<CompanyDepartment>>
}

class DefaultCompanyDepartmentsClient implements CompanyDepartmentsClient {
  client: ApiClient
  constructor() {
    this.client = initApiClient({})
  }

  async listDepartments(companyId: Identifier, params?: CompanyListDepartmentsFilterParam) {
    return this.client
      .get(`/companies/${companyId}/departments`, { params })
      .then((res) => res.data)
  }
}

const CompanyDepartmentsClientContext = createContext<CompanyDepartmentsClient>(
  new DefaultCompanyDepartmentsClient()
)

export function useCompanyDepartmentsClient() {
  return useContext(CompanyDepartmentsClientContext)
}
